var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-page-sidebar-block gl-border-b gl-border-subtle gl-py-4"},[_c('gl-button',{attrs:{"category":"primary","variant":"confirm","icon":"tanuki-ai","loading":_vm.isLoading},on:{"click":_vm.startOtelWorkflow}},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.buttonText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }